module.exports = __webpack_public_path__ + "img/logo.ec5f4d87.png";